<div class="code-editor-box">
  <ngs-code-editor
    [theme]="codeEditorTheme"
    [codeModel]="codeModel"
    [options]="codeEditorOptions"
    [readOnly]="true">
  </ngs-code-editor>
</div>

